import { all, AllEffect, fork, ForkEffect } from 'redux-saga/effects';
import avalanchAdvisorySaga from 'redux-state/avalanche-advisory/sagas.js';
import brightcoveSaga from 'redux-state/brightcove/sagas.js';
import favouriteSaga from 'redux-state/favourites/sagas.js';
import searchSaga from 'redux-state/search/sagas.js';
import weatherWarningsSaga from 'redux-state/weather-warnings/sagas.js';
import layoutSaga from './layout/sagas.js';

export function* rootSaga(): Generator<AllEffect<ForkEffect<unknown>>, void, unknown> {
  yield all([
    fork(layoutSaga),
    fork(weatherWarningsSaga),
    fork(avalanchAdvisorySaga),
    fork(favouriteSaga),
    fork(brightcoveSaga),
    fork(searchSaga),
  ]);
}
